import React from 'react'
import { Button, PauseIcon, PlayIcon, SpeakerIcon } from '@astrid/components'

import styles from './AssistControls.module.scss'

interface AssistControlsProps {
  recordingAvailable: boolean
  onPlayRecording: () => void
  onPlayAssistant: () => void
  isPlayingRecording: boolean
  isPlayingAssistant: boolean
  disableControls: boolean
  color?: 'black' | 'white'
  className?: string
}

function AssistControls({
  recordingAvailable,
  onPlayAssistant,
  onPlayRecording,
  isPlayingAssistant,
  disableControls,
  color = 'black',
  className
}: AssistControlsProps) {
  const iconColor = color === 'black' ? '#000' : '#fff'

  const PLAY_PAUSE_SVG_PROPS = {
    fill: iconColor,
    width: 22,
    height: 22
  }

  return (
    <div className={`${styles.container} ${className ?? ''}`}>
      {recordingAvailable && (
        <Button
          variant="flat"
          size="small"
          aria-label="Listen answer"
          onClick={onPlayRecording}
          disabled={disableControls}
          className={styles.controlButton}
        >
          <SpeakerIcon style={{ width: 14, height: 14 }} fill={iconColor} />
          Your answer
        </Button>
      )}
      <Button
        type="button"
        variant="flat"
        size="small"
        aria-label="Listen word"
        onClick={onPlayAssistant}
        disabled={disableControls}
        className={styles.controlButton}
      >
        {isPlayingAssistant ? <PauseIcon {...PLAY_PAUSE_SVG_PROPS} /> : <PlayIcon {...PLAY_PAUSE_SVG_PROPS} />}
        Listen
      </Button>
    </div>
  )
}

export default React.memo(AssistControls)
